import Stack from "@mui/material/Stack";
import { E_KHATTABAT_APPLICATION_STATUS } from "../../../../../../Types";
import { ONE_O_ONE_CONVERSATION_TYPES } from "../../../../../../constants/core-constants";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getKhattabat101CStore from "../../../../../../stores/khattabat-stores/101c-stores/index";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import KhattabatConversationThread from "./KhattabatConversationThread";
import KhattabatSendMessage from "./KhattabatSendMessage";

const KhattabatMessages = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { conversationID, userID } = props;
  const { conversationType, getConversationBorder } =
    getKhattabatSharedMessagingStore(conversationID);
  const applicationStatus =
    getKhattabat101CStore(userID).applicationStatus.get();

  const shouldHideSendingMessages =
    applicationStatus === E_KHATTABAT_APPLICATION_STATUS.NONE &&
    ONE_O_ONE_CONVERSATION_TYPES.includes(conversationType.get());

  return (
    <Stack
      spacing={1}
      sx={{
        ...getConversationBorder(),
        flex: 1,
        minWidth: 0,
        borderRadius: 2,
        overflow: "hidden",
        pt: 1
      }}
    >
      <KhattabatConversationThread conversationID={conversationID} />
      {shouldHideSendingMessages ? null : (
        <KhattabatSendMessage conversationID={conversationID} />
      )}
    </Stack>
  );
});

export default KhattabatMessages;
